import {
  GET_GLOBAL_SETTINGS,
  ADD_GLOBAL_SETTING,
  DELETE_GLOBAL_SETTING,
} from "../../../Types";

const AppGlobalSettingReducer = (state = [], action) => {
  switch (action.type) {
    case GET_GLOBAL_SETTINGS:
      return action.payload;
    case ADD_GLOBAL_SETTING:
      return [...state, action.payload];
    case DELETE_GLOBAL_SETTING:
      return state.filter((e) => e.id !== action.payload);
    default:
      return state;
  }
};
export default AppGlobalSettingReducer;
